import { createUseStyles } from 'react-jss';

export const useStyles = createUseStyles({
  button: {
    boxShadow: '0 0 0 0 rgba(0, 188, 212, 1)',
    animation: 'pulse 2s infinite'
  }
});

